import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
`;
